import type { SVGProps } from 'react';
import { XBoldIcon } from '@zep-us/zus/icons';
import { ICON_COLOR } from '@zep-us/zus/tokens';
import { LmsX } from '@/icons/components/LmsX';
import { useIsOXLocale } from '@/shared/hooks';
type Props = SVGProps<SVGSVGElement> & {
  color?: string;
};
export const AnswerIconX = ({
  color,
  ...props
}: Props) => {
  const isOXLocale = useIsOXLocale();
  if (isOXLocale) return <LmsX color={color} {...props} />;
  return <XBoldIcon fill={color ?? ICON_COLOR.destructive} {...props} data-sentry-element="XBoldIcon" data-sentry-component="AnswerIconX" data-sentry-source-file="AnswerIconX.tsx" />;
};